<template>
    <div id="ProgramList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> PM Compliance Pool</div>
                    <div class="web-action-btn btn-groups text-right">
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                            <i class="fp-export"></i> Export
                        </a>
                    </div>
                    <!-- <router-link v-if="canAddProgram" class="btn btn-primary pull-right" v-bind:to="{name: 'ProgramCreate'}" > <i class="fp-add"> </i> Add</router-link> -->
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content program-list">
                        <data-table-filter-config :moduleName="'PMCompliancePoolList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="data-table bg-white">
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange" :moduleName="'PMCompliancePoolList'" :position="'top'">
                                  </custom-pagination>

                                  <vue-good-table
                                      ref="listPMComplianceFacilityTable"
                                      mode="remote"
                                      title="PM Compliance Pool List"
                                      @on-page-change="onPageChange"
                                      @on-selected-rows-change="selectionChanged"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                      enabled: false,
                                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                      selectionInfoClass: 'custom-class',
                                      selectionText: 'rows selected',
                                      clearSelectionText: 'clear',
                                      }"
                                      :search-options="{
                                      enabled: false,
                                      }">

                                      <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                          <div :key="key">
                                              <!-- <div v-if="props.column.field == 'action'">
                                                  <template v-if="canUpdateProgram">
                                                      <router-link title="Edit Program" class="fp-edit mr-3" v-bind:to="{name: 'ProgramEdit',params:{id:props.row.id}}"></router-link>
                                                  </template>
                                                  <router-link title="Activity" class="fp-contracts" v-bind:to="{name: 'ProgramActivityCreate',params:{id:props.row.id}}"></router-link>
                                              </div>
                                              <div v-if="props.column.field == 'name'">
                                                      <router-link title="View Program Asset" class="color-blue" v-bind:to="{name: 'ProgramAssetMapperList',params:{id:props.row.id}}">{{props.row.name}}</router-link>
                                              </div>
                                              <div v-else> -->
                                                  {{props.formattedRow[props.column.field]}}
                                              <!-- </div> -->
                                          </div>
                                      </template>
                                  </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";
import EventBus from "./../event-bus";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';

    export default {
        name: "PMCompliancePoolList",
        metaInfo() {
            return {title: "PM Compliance Pool List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Region',
                    field: 'region',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false,
                },
                {
                    label: 'Facility',
                    field: 'location',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                },
                {
                    label: 'Equipment Type',
                    field: 'truck_type',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                },
                {
                    label: 'Pool',
                    field: 'pool',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                },
                {
                    label: 'Unit Count',
                    field: 'unit_count',
                    filterable: false,
                    fpFieldType:"integer",
                    hidden:false,
                },
                {
                    label: 'Units Late',
                    field: 'late_count',
                    filterable: false,
                    fpFieldType:"integer",
                    hidden:false,
                },
                {
                    label: 'Percent On Time',
                    field: 'percentage',
                    filterable: false,
                    fpFieldType:"integer",
                    type: 'number',
                    hidden:false,
                    sortable:false
                },
                {
                    label: 'PM Category',
                    field: 'category',
                    fpFieldType:"option",
                    filterable: false,
                    sortable:false,
                    fpMandatory:true,
                    hidden:true,
                },

            ],
            rows: [],
            totalRecords: 0,
            term_value: false,
            loading:false,
            action : '',
            batchProcess:0,
            batchNum:"",
            // canUpdateProgram:false,
            // canAddProgram:false,
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'pm_compliance_pool_report') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listPMUnitForecastTable.unselectAllInternal();
            },
            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            loadList() {
                var self = this;
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    action : self.action,
                    from:'pool'
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/pm-compliance-report/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                         if ( self.action == "export" ||  self.action == "export_queue") {

                            if ( data.code == "201" ) {
                                alert(data.message);
                            } else {

                                if ( self.action == "export" ) {

                                    self.excel = data.content.web;
                                    var save = document.createElement("a");
                                    save.href = self.excel;
                                    save.download = data.content.web;
                                    save.target = "_blank";

                                    document.body.appendChild(save);
                                    save.click();
                                    document.body.removeChild(save);

                                } else {

                                    self.batchProcess = 1;
                                    self.batchNum = data.content;
                                }

                            }

                            self.action = "list";
                            // self.loadList();

                        } else {
                          if (data.status == "success") {
                              self.rows = data.content.result.row;
                              self.totalRecords = data.content.totalRecords;
                          }
                        }

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'program-list')
                    }
                });
            },
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/reports/PMCompliancePoolReport.vue